var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgServersideIconSupport = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "12.47 12.5 25.3 25.26",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HILFSLINIEN"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_UMGEWANDELT"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#787878",
    d: "M32.657,15.594C30.66,13.607,28,12.509,25.168,12.5c-0.011,0-0.021,0-0.031,0 c-5.329,0-9.851,3.938-10.528,9.197c-0.099,1.165-0.122,2.349-0.085,3.525c-0.005,0.062-0.019,0.122-0.019,0.185v3.296 c0,1.253,1.02,2.272,2.272,2.272h0.038c1.253,0,2.272-1.02,2.272-2.272v-3.296c0-1.254-1.02-2.273-2.311-2.273 c-0.363,0-0.702,0.094-1.007,0.246c0.016-0.521,0.038-1.041,0.081-1.55c0.594-4.611,4.583-8.08,9.285-8.08c0.009,0,0.019,0,0.027,0 c2.501,0.008,4.85,0.978,6.612,2.73c1.761,1.751,2.727,4.075,2.719,6.546v0.38c-0.322-0.168-0.686-0.272-1.08-0.272 c-1.253,0-2.272,1.02-2.272,2.273v3.296c0,1.253,1.02,2.272,2.272,2.272h0.038c0.336,0,0.652-0.078,0.939-0.209 c-0.398,2.037-1.941,3.714-3.939,4.279c-0.611,0.143-1.88,0.221-2.734,0.226c-0.256-0.721-0.939-1.242-1.748-1.242h-1.694 c-1.026,0-1.861,0.835-1.861,1.86c0,1.026,0.835,1.861,1.861,1.861h1.694c0.803,0,1.483-0.515,1.743-1.229 c0.929-0.005,2.302-0.09,3.051-0.266c2.519-0.711,4.436-2.82,4.887-5.396c0.079-0.568,0.11-1.147,0.093-1.7v-6.131 C35.754,20.224,34.657,17.583,32.657,15.594z M16.815,24.384c0.563,0,1.022,0.459,1.022,1.023v3.296 c0,0.563-0.459,1.022-1.022,1.022h-0.038c-0.563,0-1.022-0.459-1.022-1.022v-3.19l0.021-0.001c-0.003-0.065,0-0.131-0.002-0.196 C15.822,24.797,16.248,24.384,16.815,24.384z M25.972,36.5h-1.694c-0.337,0-0.611-0.274-0.611-0.611s0.274-0.61,0.611-0.61h1.694 c0.337,0,0.611,0.273,0.611,0.61S26.309,36.5,25.972,36.5z M33.453,29.726h-0.038c-0.563,0-1.022-0.459-1.022-1.022v-3.296 c0-0.564,0.459-1.023,1.061-1.023c0.563,0,1.022,0.459,1.022,1.023v3.296C34.476,29.267,34.017,29.726,33.453,29.726z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_PFADE",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_24_2_",
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    d: "M27.208,35.889c0.819,0.036,2.591-0.049,3.388-0.236 c2.304-0.65,4.028-2.546,4.438-4.879c0.074-0.535,0.103-1.075,0.086-1.614v-6.133c0.017-5.452-4.44-9.885-9.954-9.902 c-5.038-0.015-9.298,3.683-9.934,8.625c-0.107,1.26-0.134,2.526-0.08,3.789"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    d: "M16.815,30.351h-0.038c-0.91,0-1.648-0.738-1.648-1.648v-3.296 c0-0.91,0.738-1.648,1.648-1.648h0.038c0.91,0,1.648,0.738,1.648,1.648v3.296C18.463,29.613,17.725,30.351,16.815,30.351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    d: "M33.453,30.351h-0.038c-0.91,0-1.648-0.738-1.648-1.648v-3.296 c0-0.91,0.738-1.648,1.648-1.648h0.038c0.91,0,1.648,0.738,1.648,1.648v3.296C35.101,29.613,34.363,30.351,33.453,30.351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    d: "M25.972,37.125h-1.695c-0.683,0-1.236-0.553-1.236-1.236l0,0 c0-0.683,0.553-1.236,1.236-1.236h1.695c0.683,0,1.236,0.553,1.236,1.236l0,0C27.208,36.572,26.654,37.125,25.972,37.125z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "BESCHRIFTUNG"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgServersideIconSupport, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/serverside-icon-support.71d829bc.svg";
export { ForwardRef as ReactComponent };